import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=ab0272d4&scoped=true"
import script from "./registration.vue?vue&type=script&lang=ts"
export * from "./registration.vue?vue&type=script&lang=ts"
import style0 from "./registration.vue?vue&type=style&index=0&id=ab0272d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0272d4",
  null
  
)

export default component.exports